// extracted by mini-css-extract-plugin
module.exports = {"modal":"AssignedPatientsModal_modal__pBbgz","inputContainer":"AssignedPatientsModal_inputContainer__3Pz46"};